import './index.scss';
import * as bootstrap from 'bootstrap';
import Plyr from 'plyr';
import assetPlyrBlank from '../assets/plyr/blank.mp4?no-inline';
import assetPlyrIcons from '~node/plyr/dist/plyr.svg?no-inline';

Plyr.defaults = {
    iconUrl: assetPlyrIcons,
    blankVideo: assetPlyrBlank,
};

import { createEnvironmentStatic } from '../lib/XEnvironment.js';
import { XPage } from '../lib/XPage.js';
import { XAccessibleDOM } from '../lib/XDOM.js';

window.createPage = function(urlPage, urlAssets)
{
    createEnvironmentStatic();
    const environment = createEnvironmentStatic();
    environment.urlRoot = urlPage;
    environment.urlAssets = urlAssets;
    const page = new XPage();
    window.page = page;
    page.initialize(new XAccessibleDOM(document));
};
